import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import Styles from '../FieldStatisticsContainer.module.less';
import PropTypes from 'prop-types';

const StandardColumnCell = ({ primary, secondary }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Typography className={Styles.title}>{primary}</Typography>
      {secondary && <Typography className={Styles.subtitle}>{secondary}</Typography>}
    </Box>
  );
};

StandardColumnCell.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
};

export default memo(StandardColumnCell);
